import { render, staticRenderFns } from "./FNBAQueEstaPasandoEnLaIndustria.vue?vue&type=template&id=22a790f6"
import script from "./FNBAQueEstaPasandoEnLaIndustria.vue?vue&type=script&lang=js"
export * from "./FNBAQueEstaPasandoEnLaIndustria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports